// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 申请授权链接 GET /seal_service/auth/apply_url */
export async function getSealServiceAuthApplyUrl(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSealServiceAuthApplyUrlParams,
  options?: { [key: string]: any },
) {
  return request<API.ESignApplyAuthResultVo>('/seal_service/auth/apply_url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 当前账号是否已授权e签宝 GET /seal_service/auth/has */
export async function getSealServiceAuthHas(options?: { [key: string]: any }) {
  return request<API.ESignHasAuthVo>('/seal_service/auth/has', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取组织信息 GET /seal_service/auth/org_info */
export async function getSealServiceAuthOrgInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSealServiceAuthOrgInfoParams,
  options?: { [key: string]: any },
) {
  return request<API.Object>('/seal_service/auth/org_info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取个人信息 GET /seal_service/auth/user_info */
export async function getSealServiceAuthUserInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSealServiceAuthUserInfoParams,
  options?: { [key: string]: any },
) {
  return request<API.Object>('/seal_service/auth/user_info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 回调服务（前端不用管） POST /seal_service/callback */
export async function postSealServiceCallback(body: string, options?: { [key: string]: any }) {
  return request<API.ResponseEntityC2ABMapC2ABObjectC2BBC2BB>('/seal_service/callback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 印章回调服务（前端不用管） POST /seal_service/seal_callback */
export async function postSealServiceSealCallback(body: string, options?: { [key: string]: any }) {
  return request<API.ResponseEntityC2ABMapC2ABObjectC2BBC2BB>('/seal_service/seal_callback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 申请印章授权 POST /seal_service/seal/apply_auth */
export async function postSealServiceSealApplyAuth(
  body: API.ESignSealApplyAuthRequest,
  options?: { [key: string]: any },
) {
  return request<API.ESignApplyAuthResultVo>('/seal_service/seal/apply_auth', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询组织被授权印章 GET /seal_service/seal/authed_list */
export async function getSealServiceSealAuthedList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSealServiceSealAuthedListParams,
  options?: { [key: string]: any },
) {
  return request<API.SPageC2ABSealDtoC2BB>('/seal_service/seal/authed_list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 查询组织内部印章 GET /seal_service/seal/own_list */
export async function getSealServiceSealOwnList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSealServiceSealOwnListParams,
  options?: { [key: string]: any },
) {
  return request<API.SPageC2ABSealDtoC2BB>('/seal_service/seal/own_list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 上传印章图片 POST /seal_service/upload/image */
export async function postSealServiceUploadImage(
  body: {},
  file?: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData();

  if (file) {
    formData.append('file', file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === 'object' && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ''));
        } else {
          formData.append(ele, JSON.stringify(item));
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<API.EsignSealUploadVo>('/seal_service/upload/image', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}
